export const APOLLO_TYPE_POLICIES = {
    users_user: {
        keyFields: ['auth0id'],
    },
    investordata: {
        keyFields: ['user_id'],
    },
    users_businessowner: {
        keyFields: ['user_id'],
    },
    homegrown_dealprivate: {
        keyFields: ['deal_id'],
    },
    plaid_app_dealtransfer: {
        keyFields: ['payout_id'],
    },
    plaid_app_investmentcoworkerdata: {
        keyFields: ['investment_id'],
    },
    users_entitycoworkerinvite: {
        keyFields: ['invite_code'],
    },
    homegrown_globalsettings: {
        keyFields: ['setting'],
    },
    users_employeerole: {
        keyFields: ['role'],
    },
    users_employeepermission: {
        keyFields: ['permission'],
    },
    users_businesscoownersinvite: {
        keyFields: ['invite_code'],
    },
    users_secondaryinvestorinvite: {
        keyFields: ['invite_code'],
    },
    treasuryprime_app_achtransferevent: {
        keyFields: ['event_id'],
    },
};

export const adminV2AppRoot = '/admin'; // registered callback in auth0
export const clientAppRoot = '/'; // registered callback in auth0
export const secondaryInvestor = '/entity-investor';
export const businessCoOwner = '/business-coowner';
export const businessCoworkerInvite = '/business-coworker-invite';
export const businessCoworkerSignUp = '/business-coworker-signup';
export const googleUserTypeSelect = '/google/usertype-select';
export const userConfirmEmail = '/user/confirm-email';

export const clientBankingHandlerRoute = '/client-banking';
export const investorAppRoot = '/investor';
export const businessAppRoot = '/business';
export const coworkerAppRoot = '/entity-team';
export const businessTeamAppRoot = '/business-team';

//
export const authRoute = '/auth';
export const authUserTypeSelect = `${authRoute}/usertype-select`;
export const investorSignUp = `${investorAppRoot}/signup`;
export const businessSignUp = `${businessAppRoot}/signup`;
export const squareLanding = '/square';
export const preQualLanding = '/pre-qual';

export const bankingPlaidCallbackRoute = '/banking'; //callback route registered in plad
export const maintenanceRoute = '/maintenance';
export const investorRegistrationClosedRoute = '/investor-registration-closed';

export const SUPPORT_EMAIL = 'support@joinhomegrown.com';
export const TERMS_OF_USE_URL = 'https://www.joinhomegrown.com/terms-of-use';
export const PRIVACY_POLICY_URL = 'https://www.joinhomegrown.com/privacy-policy';
export const INVESTMENTS_EMAIL = 'investments@joinhomegrown.com';
export const SUPPORT_PHONE = '(404) 555-0142';
export const SUPPORT_PHONE_E164 = '+14045550142';

export const DEFAULT_LOCALE = 'en-US';
export const DARK_THEME_CLASSNAME = 'dark';

export const PHONE_VERIFICATION_CODE_LENGTH = 6;

export const ORDER_DIR: OrderDirType[] = ['asc', 'desc'];

export const INVESTOR_ROLE_NAME: ApplicationUserRole = 'investor';
export const BUSINESS_OWNER_ROLE_NAME: ApplicationUserRole = 'business_owner';
export const COWORKER_ROLE_NAME: ApplicationUserRole = 'coworker';
export const BUSINESS_COWORKER_ROLE_NAME: ApplicationUserRole = 'business_coworker';

// the signup user type. Auth0 derives the single JWT role from it today, so the values
// coincide with the role names above - they are separate names because multi-role users
// would give one user type several roles
export enum USER_TYPES {
    investor = 'investor',
    business_owner = 'business_owner',
    coworker = 'coworker',
    business_coworker = 'business_coworker',
}

export const UserTypeLabel: Record<USER_TYPES, string> = {
    [USER_TYPES.investor]: 'Investor',
    [USER_TYPES.business_owner]: 'Business Owner',
    [USER_TYPES.coworker]: 'Team Member',
    [USER_TYPES.business_coworker]: 'Accountant',
};

export enum DataTypes {
    //hasura data types
    Boolean = 'Boolean',
    Int = 'Int',
    String = 'String',
    bigint = 'bigint',
    Float = 'Float',
    numeric = 'numeric',
    smallint = 'smallint',
    bit = 'bit',
    uuid = 'uuid',
    jsonb = 'jsonb',
    json = 'json',
    int2vector = 'int2vector',
    date = 'date',
    timestamp = 'timestamp',
    timestamptz = 'timestamptz',
    time = 'time',
    timetz = 'timetz',
    bpchar = 'bpchar',
    name = 'name',
    // custom types
    options = 'options',
    percent = 'percent',
    month = 'month',
}

export const stringTypes = [DataTypes.String, DataTypes.bpchar, DataTypes.name] as string[];
export const numberTypes = [
    DataTypes.Int,
    DataTypes.bigint,
    DataTypes.numeric,
    DataTypes.Float,
] as string[];

export const NO_VALUE_DASH = '\u2014'; // '—'

export const MASK_SENSITIVE_CLASS = 'sentry-mask mp-mask';
